// extracted by mini-css-extract-plugin
module.exports = {"cookie":"styles_cookie__1j33H","wrapper":"styles_wrapper__2_5Py","link":"styles_link__2dBle","close":"styles_close__2cqtf"};